/*
 *
 * ForeignCardDetail
 *
 * @version 1.0.0
 * @author Giorgia Cuozzo
 * @since 25-Feb-2025
*/

import ForeignCardDetail from './ForeignCardDetailContainer'

export default ForeignCardDetail
